/** Toont vandaag's nog-lopende/aankomende Google Calendar-afspraken bovenaan de Today-pagina; verborgen als er geen zijn. */
import { Box, Typography } from '@mui/material';
import Panel from '@/components/ui/Panel';
import { useGCalEventsForRange } from '@/features/planning/hooks/use-gcal-events-for-range';
import {
  getGCalEventStartDate,
  isGCalAllDayEvent,
} from '@/features/planning/utils/gcalHorizonUtils';
import { taskRowBorderLeftSx, FONT_WEIGHT_SEMIBOLD } from '@/components/ui/taskVisualTokens';
import { useT } from '@/i18n/useT';

const pad = (value) => String(value).padStart(2, '0');
const formatTime = (date) => `${pad(date.getHours())}:${pad(date.getMinutes())}`;

const TodayAppointmentsPanel = () => {
  const t = useT();
  const today = new Date();
  const now = Date.now();
  const events = useGCalEventsForRange(today, today);

  const timedEvents = events
    .filter((event) => !isGCalAllDayEvent(event))
    .map((event) => {
      const start = getGCalEventStartDate(event);
      const end = event.end?.dateTime ? new Date(event.end.dateTime) : null;
      return { event, start, end };
    })
    .filter(({ end, start }) => (end ? end.getTime() : start.getTime()) >= now)
    .sort((a, b) => a.start - b.start);

  if (timedEvents.length === 0) return null;

  return (
    <Panel
      flat
      testId="panel-appointments"
      title={t('todayviewcontent.appointments', 'Afspraken')}
      count={timedEvents.length}
      tabIndex={-1}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, px: 1.5, py: 1 }}>
        {timedEvents.map(({ event, start, end }) => {
          const ongoing = start.getTime() <= now && (!end || end.getTime() >= now);
          return (
            <Box
              key={event.id}
              sx={{
                display: 'flex',
                gap: 1,
                alignItems: 'baseline',
                py: 0.5,
                pl: 1,
                ...taskRowBorderLeftSx(ongoing ? 'primary.main' : undefined, false),
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontVariantNumeric: 'tabular-nums', color: 'text.secondary', minWidth: 88 }}
              >
                {end ? `${formatTime(start)}–${formatTime(end)}` : formatTime(start)}
              </Typography>
              <Typography
                variant="body2"
                sx={{ flex: 1, fontWeight: ongoing ? FONT_WEIGHT_SEMIBOLD : undefined }}
              >
                {event.summary || t('todayviewcontent.appointmentUntitled', '(Geen titel)')}
                {event.location ? (
                  <Typography component="span" variant="caption" sx={{ color: 'text.secondary', ml: 0.75 }}>
                    · {event.location}
                  </Typography>
                ) : null}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Panel>
  );
};

export default TodayAppointmentsPanel;
